import { RouteObjectRule } from "../router";
import { lazy, ReactNode, Suspense } from "react";
import { LuckLoading, LuckProgress } from '../../components/Luck';

export const lazyLoad = (children: ReactNode): ReactNode => {
	return (
		<Suspense fallback={
			<LuckProgress><LuckLoading /></LuckProgress>
		}>
			{children}
		</Suspense>
	)
}
//,美中国际
const CaseIndex = lazy(() => import('../../pages/Usaedu/Case/List'))
const CaseInfo = lazy(() => import('../../pages/Usaedu/Case/Info'))
const StudentIndex = lazy(() => import('../../pages/Usaedu/Student/List'))
const StudentInfo = lazy(() => import('../../pages/Usaedu/Student/Info'))
const ProjectIndex = lazy(() => import('../../pages/Usaedu/Project/List'))
const ProjectListAdd = lazy(() => import('../../pages/Usaedu/Project/List/add'))
const ProjectListEdit = lazy(() => import('../../pages/Usaedu/Project/List/edit'))
const ProjectCategory = lazy(() => import('../../pages/Usaedu/Project/Category'))


const MvideoIndex = lazy(() => import('../../pages/Usaedu/Mvideo/List'))
const MvideoListAdd = lazy(() => import('../../pages/Usaedu/Mvideo/List/add'))
const MvideoListEdit = lazy(() => import('../../pages/Usaedu/Mvideo/List/edit'))
const MvideoCategory = lazy(() => import('../../pages/Usaedu/Mvideo/Category'))

const MeatIndex = lazy(() => import('../../pages/Usaedu/Meat/List'))
const MeatListAdd = lazy(() => import('../../pages/Usaedu/Meat/List/add'))
const MeatListEdit = lazy(() => import('../../pages/Usaedu/Meat/List/edit'))
const MeatCategory = lazy(() => import('../../pages/Usaedu/Meat/Category'))

const TutorIndex = lazy(() => import('../../pages/Usaedu/Tutor/List'))
const TutorListAdd = lazy(() => import('../../pages/Usaedu/Tutor/List/add'))
const TutorListEdit = lazy(() => import('../../pages/Usaedu/Tutor/List/edit'))

const LotteryIndex = lazy(() => import('../../pages/Usaedu/Lottery'))

//系统路由
const SystemDictList = lazy(() => import('../../pages/System/Dict/List'))
const SystemDictValue = lazy(() => import('../../pages/System/Dict/Value'))

//院校路由
const SchoolIndex = lazy(() => import('../../pages/School/List'));
const SchoolAdd = lazy(() => import('../../pages/School/List/add'));
const SchoolEdit = lazy(() => import('../../pages/School/List/edit'));
const SchoolMajorIndex = lazy(() => import('../../pages/School/Major/List'));
const SchoolMajorCate = lazy(() => import('../../pages/School/Major/Cate'));


export const CaseRouter: RouteObjectRule[] = [
	{
		path: "/usaedu/case",
		// element: <CaseIndex />,
		children: [
			{
				index: true,
				element: lazyLoad(<CaseInfo />),
				key: '/usaedu/case/info',
			},
			{
				path: "/usaedu/case/list",
				element: lazyLoad(<CaseIndex />)
			}
		]
	}
];
//学生
export const StudentRouter: RouteObjectRule[] = [
	{
		path: "/usaedu/student",
		children: [
			{
				path: "/usaedu/student/list",
				element: lazyLoad(<StudentIndex />)
			},
			{
				path: "/usaedu/student/info/:id",
				element: lazyLoad(<StudentInfo />)
			}
		]
	}
];

//美中国际
export const UsaeduRouter: RouteObjectRule[] = [
	{
		path: "/usaedu",
		children: [
			{
				path: "/usaedu/project/list",
				element: lazyLoad(<ProjectIndex />)
			},
			{
				path: "/usaedu/project/add",
				element: lazyLoad(<ProjectListAdd />)
			},
			{
				path: "/usaedu/project/edit/:id",
				element: lazyLoad(<ProjectListEdit />)
			},
			{
				path: "/usaedu/project/category",
				element: lazyLoad(<ProjectCategory />)
			},
			//老师
			{
				path: "/usaedu/tutor/list",
				element: lazyLoad(<TutorIndex />)
			},
			{
				path: "/usaedu/tutor/add",
				element: lazyLoad(<TutorListAdd />)
			},
			{
				path: "/usaedu/tutor/edit/:id",
				element: lazyLoad(<TutorListEdit />)
			},

			{
				path: "/usaedu/mvideo/list",
				element: lazyLoad(<MvideoIndex />)
			},
			{
				path: "/usaedu/mvideo/add",
				element: lazyLoad(<MvideoListAdd />)
			},
			{
				path: "/usaedu/mvideo/edit/:id",
				element: lazyLoad(<MvideoListEdit />)
			},
			{
				path: "/usaedu/mvideo/category",
				element: lazyLoad(<MvideoCategory />)
			},

			{
				path: "/usaedu/meat/list",
				element: lazyLoad(<MeatIndex />)
			},
			{
				path: "/usaedu/meat/add",
				element: lazyLoad(<MeatListAdd />)
			},
			{
				path: "/usaedu/meat/edit/:id",
				element: lazyLoad(<MeatListEdit />)
			},
			{
				path: "/usaedu/meat/category",
				element: lazyLoad(<MeatCategory />)
			},
			{
				path: "/usaedu/lottery",
				element: lazyLoad(<LotteryIndex />)
			},

		]
	}
];

export const SystemRouter: RouteObjectRule[] = [
	{
		path: "/system/dict",
		// element: <CaseIndex />,
		children: [
			{
				path: "/system/dict/list",
				element: lazyLoad(<SystemDictList />)
			},
			{
				path: "/system/dict/value",
				element: lazyLoad(<SystemDictValue />)
			}
		]
	}
];


export const SchoolRouter: RouteObjectRule[] = [
	{
		key: '/school',
		path: "/school",
		children: [
			{
				key: '/school/list',
				path: "/school/list",
				element: lazyLoad(<SchoolIndex />)
			},
			{
				path: "/school/add",
				element: lazyLoad(<SchoolAdd />)
			},
			{
				path: "/school/edit/:id",
				element: lazyLoad(<SchoolEdit />)
			},
			{
				path: "/school/major/list",
				element: lazyLoad(<SchoolMajorIndex />)
			},
			{
				path: "/school/major/cate",
				element: lazyLoad(<SchoolMajorCate />)
			}
		]
	}
];